import * as types from '../../../../constants/ActionNameConstants';

// Side panel preview: first page only, no search or sort.
export const glossaryPreviewRequest = (payload) => ({
  type: types.GET_GLOSSARY_PREVIEW_REQUEST,
  payload, // full API params object, incl. audilfileId
});

export const glossaryPreviewSuccess = (payload) => ({
  type: types.GET_GLOSSARY_PREVIEW_SUCCESS,
  payload, // { params, items, totalCount }
});

export const glossaryPreviewFailure = (payload) => ({
  type: types.GET_GLOSSARY_PREVIEW_FAILED,
  payload, // { params, message }
});

// Modal list: paged, searchable, sortable.
export const glossaryListRequest = (payload) => ({
  type: types.GET_GLOSSARY_LIST_REQUEST,
  payload,
});

export const glossaryListSuccess = (payload) => ({
  type: types.GET_GLOSSARY_LIST_SUCCESS,
  payload, // { params, items, totalCount } — params carry the page, so the
  // reducer knows whether to replace (page 1) or append (page > 1).
});

export const glossaryListFailure = (payload) => ({
  type: types.GET_GLOSSARY_LIST_FAILED,
  payload, // { params, message }
});

// Opening doubles as the reset: every open starts at page 1, no search,
// default sort. The audio file id scopes the request.
export const openGlossaryModal = (audilfileId) => ({
  type: types.OPEN_GLOSSARY_MODAL,
  payload: audilfileId,
});

export const closeGlossaryModal = () => ({ type: types.CLOSE_GLOSSARY_MODAL });

export const setGlossarySearch = (value) => ({ type: types.SET_GLOSSARY_SEARCH, payload: value });

// No payload: the reducer advances the cycle itself, so a fast double-click
// cannot desync through a stale closure.
export const cycleGlossarySort = () => ({ type: types.CYCLE_GLOSSARY_SORT });

// Guarded inside the reducer, so it is safe to dispatch on every observer hit.
export const nextGlossaryPage = () => ({ type: types.NEXT_GLOSSARY_PAGE });

export const retryGlossaryList = () => ({ type: types.RETRY_GLOSSARY_LIST });

export const resetGlossaryState = () => ({ type: types.RESET_GLOSSARY_STATE });
